import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
} from "../actions/types";
const UPDATE_APP_LOGOUT = "UPDATE_APP_LOGOUT"
const SET_USER_NULL = "SET_USER_NULL"

const user = JSON.parse(localStorage.getItem("user"));
//console.log(localStorage)
const userInfo = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

const initialState = {...userInfo,
  forApp: {logout: false, h: 11, t: 'hello'}
}


export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case UPDATE_APP_LOGOUT:

      return {
        ...state,
        forApp: {...state.forApp, logout: action.value}
      };
    case SET_USER_NULL:

    return {
      ...state,
      user: null
    };
    default:
      return state;
  }
}

export const updateAppLogout = (value) => ({ type: UPDATE_APP_LOGOUT, value});
export const setUserNull = () => ({ type: SET_USER_NULL});
//RESET_LOGIN_IN